import { combineReducers } from "redux";
import HomeReducer from "./Files/FileReducer";
import snackBarReducer from "./SnackBar/SnackBarReducer";
import UserReducer from './User/UserReducer'
const rootReducer = combineReducers( {
    allFiles : HomeReducer,
    snackBar: snackBarReducer,
    user: UserReducer
})

export default rootReducer
